export const liveTracking = {
  NA: "N/A",
  times: "0 Times | 1 Time | {val} Times",
  refresh: "Refresh",
  noData: "@:common.global.noData",
  unknownDriver: "@:common.global.unknownDriver",
  fleetOrVehicleID: "Fleet or Vehicle ID",
  activeVehicles: "Active Vehicles",
  nonActiveVehicles: "Non-Active Vehicles",
  fleet: "Fleet",
  model: "Vehicle Model",
  speed: "Speed",
  location: "Location",
  DSS: "DSS",
  fatigue: "Fatigue",
  phoneUsage: "Phone Usage",
  smoking: "Smoking",
  PDCritical: "PD - Critical",
  front: "Front",
  rear: "Rear",
  left: "Left",
  right: "Right",
  cameraBlocked: "Camera Blocked",
  unauthorizedDrivers: "Unauthorized Drivers",
  geofencing: "Geofencing",
  enter: "Enter",
  exit: "Exit",
  speeding: "Speeding",
  seatbelt: "SeatBelt Unfastened",
  unassignedVehicles: "Unassigned Vehicles",
  search4NoVehicleTips: "Vehicle is not registered.",
  realtimeVideo: "Realtime Video",
  offLineTime: "Offline Time",
  noSignal: "No Signal",
  SDCardError: "SD Unrecognized",
  hardHatOff: "Hardhat Off",
  cameraShift: "Camera Shift",
  leaveSeat: "Leave Seat",
  extDssSDCardError: "Extended SD Unrecognized",
  deviceIsBusy: "The system is busy now, please try again later.",
  deviceUnResponse: "The system is not responding, please try again later.",
  deviceIsOffline: "The system is offline now",
  videoFailure: "Playback failed.",
  resourceFailure: "Loading failed.",
  driverChanged: "Driver Changed",
  videoExceedQuota: "you have exceeded your real-time video limit.",
  frontRight: "Front Right",
  rearRight: "Rear Right",
};
